module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tiles",
    on: {
      "keydown": _vm.move
    }
  }, _vm._l((_vm.tiles), function(row, index) {
    return _c('row', {
      key: index,
      staticClass: "row",
      attrs: {
        "row": row,
        "from": -2
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-40a114e2"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/gamecontainer/tiles/index.vue
// module id = 38
// module chunks = 0